<template>
  <form-section
    :title="$t('CampaignForm_Events_MessageLimits_Title')"
    :description="$t('CampaignForm_Events_MessageLimits_Description')"
    :separator="true"
    :is-changed="model.diff && model.diff.includes('eventLimits')"
  >
    <!-- max number of triggers -->
    <form-item
      :label="$t('CampaignForm_Events_MessageLimits_MaxTriggers')"
      class="input-group"
    >
      <el-input-number
        class="limit-input-number"
        v-model="model.event_limit_per_user"
        :placeholder="$t('CampaignForm_Events_MessageLimits_Unlimited')"
        :controls="false"
        :min="0"
        :max="1000"
        data-qa="maximum-trigger-input"
      />
      <el-select
        v-model="model.event_limit_per_user_scope"
        data-qa="maximum-trigger-scope-dropdown"
      >
        <el-option
          value="profile"
          :label="$t('CampaignForm_Events_MessageLimits_PerUser')"
          data-qa="maximum-trigger-user-option"
        />
        <el-option
          value="device"
          :label="$t('CampaignForm_Events_MessageLimits_PerDevice')"
          data-qa="maximum-trigger-device-option"
        />
      </el-select>
      <el-select
        v-model="model.event_limit_per_user_period"
        data-qa="maximum-trigger-period-dropdown"
      >
        <el-option
          value="day"
          :label="$t('CampaignForm_Events_MessageLimits_PerDay')"
          data-qa="maximum-trigger-day-option"
        />
        <el-option
          value="calendar_day"
          :label="$t('CampaignForm_Events_MessageLimits_PerCalendarDay')"
          data-qa="maximum-trigger-calendar-day-option"
        />
        <el-option
          value="campaign"
          :label="$t('CampaignForm_Events_MessageLimits_PerCampaign')"
          data-qa="maximum-trigger-campaign-option"
        />
      </el-select>
    </form-item>

    <!-- Number of events before first trigger -->
    <form-item v-if="allowNumBefTrigger">
      <template #label>
        {{ $t('CampaignForm_Events_MessageLimits_NumBefTrigger') }}
        <form-item-i-tooltip
          v-if="isPreferenceTrigger"
          :tooltip-content="
            $t('CampaignForm_Events_MessageLimits_NumBefTrigger_Disabled')
          "
        />
      </template>
      <el-input-number
        class="limit-input-number"
        v-model="model.event_limit_nth_hit"
        :controls="false"
        :min="0"
        :max="1000"
        :disabled="isPreferenceTrigger"
        data-qa="first-trigger-input"
      />
      <el-select
        v-model="model.event_limit_nth_hit_scope"
        :disabled="isPreferenceTrigger"
        data-qa="first-trigger-scope-dropdown"
      >
        <el-option
          value="profile"
          :label="$t('CampaignForm_Events_MessageLimits_PerUser')"
          data-qa="first-trigger-user-option"
        />
        <el-option
          value="device"
          :label="$t('CampaignForm_Events_MessageLimits_PerDevice')"
          data-qa="first-trigger-device-option"
        />
      </el-select>
      <el-select
        v-model="model.event_limit_nth_hit_period"
        :disabled="isPreferenceTrigger"
        data-qa="first-trigger-period-dropdown"
      >
        <el-option
          value="day"
          :label="$t('CampaignForm_Events_MessageLimits_PerDay')"
          data-qa="first-trigger-day-option"
        />
        <el-option
          value="calendar_day"
          :label="$t('CampaignForm_Events_MessageLimits_PerCalendarDay')"
          data-qa="first-trigger-calendar-day-option"
        />
        <el-option
          value="campaign"
          :label="$t('CampaignForm_Events_MessageLimits_PerCampaign')"
          data-qa="first-trigger-campaign-option"
        />
      </el-select>
    </form-item>

    <journey-option-enter-once
      :model="model"
      v-if="model.type === campaignTypeEnum.TYPE_WORKFLOW"
    />
  </form-section>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import FormItemITooltip from '@/common/components/form/FormItemITooltip'
import FormSection from '@/common/components/form/FormSection'
import JourneyOptionEnterOnce from '@/modules/campaign-manage/components/JourneyOptionEnterOnce.vue'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import { campaignSystemEvents } from '@/modules/campaigns/enum/CampaignSystemEventEnum'

export default {
  name: 'MessageLimits',

  components: {
    FormItem,
    FormItemITooltip,
    FormSection,
    JourneyOptionEnterOnce
  },

  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      campaignTypeEnum,
      campaignSystemEvents
    }
  },

  created() {
    if (this.model.event_limit_per_user === null && !this.model.id) {
      this.model.event_limit_per_user = 1
    }
    if (this.model.event_limit_per_user_scope === null) {
      this.model.event_limit_per_user_scope = 'profile'
    }
    if (this.model.event_limit_per_user_period === null) {
      this.model.event_limit_per_user_period = 'day'
    }
    if (this.model.event_limit_nth_hit_scope === null) {
      this.model.event_limit_nth_hit_scope = 'profile'
    }
    if (this.model.event_limit_nth_hit_period === null) {
      this.model.event_limit_nth_hit_period = 'day'
    }
  },

  computed: {
    allowNumBefTrigger() {
      return this.$hasFeature('inappEventsBeforeTrigger')
    },
    isPreferenceTrigger() {
      return (
        this.model.event === this.campaignSystemEvents.EVENT_PREFERENCE_TRIGGER
      )
    }
  }
}
</script>

<style scoped>
>>> .el-form-item__content {
  display: flex;
}

>>> .el-form-item__content > div:first-of-type {
  width: 80px;
  padding-right: 10px;
}

>>> .el-form-item__content > div:not(:first-of-type) {
  width: 165px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/events/MessageLimits.vue